import React from 'react';
import CalendarMangementRouter from './CalendarMangementRouter';

export default function CalendarMangementPage() {
  return <CalendarMangementRouter />;
}
